'use strict';

// const $ = (el) => document.querySelector(el);
const $$ = (el) => document.querySelectorAll(el);

class MainNav {
  /**
   * Initialized the Main Navigation
   */
  constructor(sel) {
    let mainMenu = document.querySelector(sel);
    
    if (mainMenu) {
      const toggle = mainMenu.querySelector('.toggle');
      toggle.addEventListener('click', () => {
        mainMenu.classList.toggle('opened');
      });

      const hasChildren = mainMenu.querySelectorAll('.has-children');

      hasChildren.forEach((child) => {
        child.addEventListener('click', (e) => {
          if (child == e.target || e.target === child.firstElementChild) {
            e.preventDefault();
            e.stopPropagation();
            child.classList.toggle('opened');
          }
        });

        if (window.innerWidth > 1024) {
          // child.style.width = `${child.offsetWidth}px`;
  
          const hoverEvent = (e) => {
            e.currentTarget.querySelectorAll('li').forEach((item) => {
              item.style.width = `${item.offsetWidth}px`;
            });
  
            child.removeEventListener('mouseover', hoverEvent);
          };
  
          child.addEventListener('mouseover', hoverEvent);
        }
      });

      addEventListener('scroll', () => {
        if (window.scrollY > 80) {
          $$('header, header .wrapper').forEach((child) => {
            child.classList.add('on-scroll');
          });
        } else {
          $$('header, header .wrapper').forEach((child) => {
            child.classList.remove('on-scroll');
          });
        }
      });
    }
  }
}

export default MainNav;
